import { type RootState } from '../store'
import { type Notification } from './types'

export const selectNotifications = (state: RootState): Notification[] =>
  state.notifications.notifications
